exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.verte[data-v-17ecd8f6] {\n    justify-content: left;\n}\n.error-block[data-v-17ecd8f6] {\n    display: none;\n    color: red;\n    font-weight: bold;\n}\n", ""]);

// exports
